/* Q4 · Pop-up «10 % en tu primer pedido» (24-oct-2026). Sección sections/q4-bienvenida-10.liquid.
   - Abre una vez por visita según la página (celular, ficha o computador) y nunca encima de otro diálogo (carrito, menú).
   - Cerrado: no vuelve a abrirse solo por N días (queda la píldora en la visita). Correo dejado o código ya en el
     carrito: no vuelve nunca en ese navegador.
   - Al suscribirse aplica el código al carrito y le pide al carrito Q4 que se refresque: la sección se vuelve a pintar
     con el total ya descontado y regalos() agrega o quita los premios de la escalera según ese total.
   - ?q4bv=<aroma> (correos del regalo anterior) deja ese regalo en el atributo _bienvenida del carrito, como antes. */
(() => {
  const CLAVE = 'q4bv10';
  const RAIZ = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const CORREO_OK = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const leer = (alm, k) => { try { return JSON.parse(alm.getItem(k)); } catch { return null; } };
  const guardar = (alm, k, v) => { try { alm.setItem(k, JSON.stringify(v)); } catch {} };
  const plata = (centavos) => '$' + Math.round(centavos / 100).toLocaleString('es-CL');
  const esperar = (ms) => new Promise((r) => setTimeout(r, ms));
  const pc = () => window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches;

  const carritoQ4 = () => { const el = document.querySelector('[data-q4c]'); return el && el._q4c; };
  async function leerCarrito() {
    const r = await fetch(RAIZ + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.ok ? r.json() : null;
  }
  async function postCarrito(datos) {
    const r = await fetch(RAIZ + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    });
    if (!r.ok) throw new Error('carrito ' + r.status);
    return r.json();
  }
  // El carrito Q4 vuelve a pintar su sección (total ya descontado) y corre regalos(): la escalera se mide de nuevo.
  async function refrescarCarrito() {
    const c = carritoQ4();
    if (c && c.encolar && c.refrescar) await c.encolar(() => c.refrescar());
  }
  function tieneCodigo(cart, codigo) {
    return !!(cart && (cart.discount_codes || []).some((d) => String(d.code).toUpperCase() === codigo));
  }

  // Correos del regalo anterior: ?q4bv=<aroma> deja el regalo en el carrito (el carrito Q4 lo suma a $0 desde el mínimo).
  async function regaloDesdeCorreo(el) {
    const aroma = (location.search.match(/[?&]q4bv=([a-z0-9-]+)/) || [])[1];
    if (!aroma || aroma === 'abrir') return false;
    const mapa = {};
    (el.dataset.regalos || '').split(',').forEach((par) => {
      const [k, v] = par.split(':').map((x) => (x || '').trim());
      if (k && v) mapa[k] = v;
    });
    if (!mapa[aroma]) return false;
    try { await postCarrito({ attributes: { _bienvenida: mapa[aroma] } }); await refrescarCarrito(); } catch {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('q4_bienvenida_desde_correo', { aroma }); } catch {}
    return true;
  }

  class Bienvenida10 {
    constructor(el) {
      this.el = el;
      this.cfg = el.dataset;
      this.codigo = String(this.cfg.codigo || '').toUpperCase();
      this.d = el.querySelector('[data-q4bv-dialogo]');
      this.form = el.querySelector('[data-q4bv-form]');
      this.pildora = el.querySelector('[data-q4bv-pildora]');
      this.prueba = this.cfg.prueba === 'true';
      this.editor = !!(window.Shopify && window.Shopify.designMode);
      this.timer = null;
      this.listoVisible = false;

      el.addEventListener('click', (e) => this.alClic(e));
      window.addEventListener('submit', (e) => this.enviar(e), true);
      const correo = this.form.querySelector('[data-q4bv-correo]');
      correo.addEventListener('blur', () => { if (correo.value) this.validar(false); });
      correo.addEventListener('input', () => { if (this.form.querySelector('[data-q4bv-campo]').dataset.error === 'true') this.validar(false); });
      this.d.addEventListener('cancel', (e) => { e.preventDefault(); this.cerrar(); });
      this.d.addEventListener('close', () => document.documentElement.classList.remove('q4bv-bloqueo'));
      if (this.pildora) this.pildora.addEventListener('click', () => this.abrir());
      if (!this.editor) this.programar();
    }

    async programar() {
      // Vuelta del envío del formulario (el formulario de clientes recarga la página)
      const pend = leer(sessionStorage, CLAVE + '-pend');
      if (pend) {
        try { sessionStorage.removeItem(CLAVE + '-pend'); } catch {}
        if (this.el.querySelector('[data-q4bv-ok-servidor]') || /[?&]customer_posted=true/.test(location.search)) {
          await this.exito(pend.c);
          return;
        }
        if (this.el.querySelector('[data-q4bv-error-servidor]')) {
          this.form.querySelector('[data-q4bv-correo]').value = pend.c || '';
          this.error(this.cfg.txtEnvio);
          this.abrir();
          return;
        }
      }
      if (/[?&]q4bv=abrir/.test(location.search)) { this.abrir(); return; }

      const st = leer(localStorage, CLAVE) || {};
      if (st.e === 'listo') return;
      const viejo = leer(localStorage, 'q4bv') || {};
      if (viejo.e === 'listo') return; // ya se suscribió al pop-up del regalo
      const dias = (parseInt(this.cfg.dias, 10) || 7) * 864e5;
      if (st.e === 'cerrado' && Date.now() - st.t < dias) {
        if (leer(sessionStorage, CLAVE + '-pildora')) this.verPildora(true);
        return;
      }
      // Si el código ya está en el carrito (lo escribió a mano o vino de un correo), no hace falta ofrecerlo
      try {
        const cart = await leerCarrito();
        if (tieneCodigo(cart, this.codigo)) { guardar(localStorage, CLAVE, { e: 'listo', t: Date.now() }); return; }
      } catch {}

      const n = (parseInt(sessionStorage.getItem(CLAVE + '-paginas'), 10) || 0) + 1;
      try { sessionStorage.setItem(CLAVE + '-paginas', String(n)); } catch {}

      if (pc() || this.cfg.plantilla === 'product') {
        // Computador y fichas: a los segundos, al bajar hasta el % o (computador) al intentar salir; lo que pase primero
        const seg = (parseFloat(pc() ? this.cfg.pcSegundos : this.cfg.fichaSegundos) || 15) * 1e3;
        const tope = (parseFloat(this.cfg.bajada) || 50) / 100;
        const caja = document.querySelector('.page-wrapper');
        let hecho = false;
        const ir = () => {
          if (hecho) return;
          hecho = true;
          clearTimeout(this.timer);
          window.removeEventListener('scroll', bajar);
          if (caja) caja.removeEventListener('scroll', bajar);
          document.removeEventListener('mouseout', salir);
          this.precargar();
          this.intentar();
        };
        const bajar = () => {
          const enCaja = caja && caja.scrollHeight > caja.clientHeight + 2;
          const alto = enCaja ? caja.scrollHeight - caja.clientHeight : document.documentElement.scrollHeight - window.innerHeight;
          const y = enCaja ? caja.scrollTop : window.scrollY;
          if (alto > 0 && y / alto >= tope) ir();
        };
        const salir = (e) => { if (!e.relatedTarget && e.clientY <= 0) ir(); };
        window.addEventListener('scroll', bajar, { passive: true });
        if (caja) caja.addEventListener('scroll', bajar, { passive: true });
        if (pc()) document.addEventListener('mouseout', salir);
        this.timer = setTimeout(ir, seg);
        return;
      }
      // Celular fuera de las fichas: a los segundos, o casi enseguida desde la página número N
      const s = parseFloat(this.cfg.segundos);
      const seg = (isNaN(s) ? 8 : Math.max(0, s)) * 1e3;
      const paginas = parseInt(this.cfg.paginas, 10) || 2;
      const espera = n >= paginas ? Math.min(seg, 2500) : seg;
      setTimeout(() => this.precargar(), Math.max(0, espera - 2000));
      this.timer = setTimeout(() => this.intentar(), espera);
    }

    precargar() { this.el.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; }); }

    // Nunca encima de otro diálogo abierto (carrito, menú, filtros): espera a que se cierre y 3 s más
    intentar() {
      const otro = Array.from(document.querySelectorAll('dialog[open], details.menu-drawer-container[open]')).find((x) => x !== this.d);
      if (otro) {
        otro.addEventListener(otro.localName === 'dialog' ? 'close' : 'toggle', () => { this.timer = setTimeout(() => this.intentar(), 3e3); }, { once: true });
        return;
      }
      if (document.hidden) { document.addEventListener('visibilitychange', () => this.intentar(), { once: true }); return; }
      const css = document.querySelector('link[href*="q4-bienvenida-10.css"]');
      if (css && css.media === 'print') { css.addEventListener('load', () => this.intentar(), { once: true }); return; }
      this.abrir();
    }

    abrir() {
      clearTimeout(this.timer);
      this.verPildora(false);
      this.precargar();
      if (this.d.open) return;
      try { this.d.showModal(); } catch { this.d.setAttribute('open', ''); }
      document.documentElement.classList.add('q4bv-bloqueo');
      this.d.setAttribute('tabindex', '-1');
      this.d.focus({ preventScroll: true });
      this.evento('q4_bienvenida10_visto', {});
    }

    cerrar() {
      if (!this.d.open) return;
      this.d.close();
      document.documentElement.classList.remove('q4bv-bloqueo');
      if (this.editor || this.listoVisible) return;
      guardar(localStorage, CLAVE, { e: 'cerrado', t: Date.now() });
      guardar(sessionStorage, CLAVE + '-pildora', true);
      this.verPildora(true);
    }

    verPildora(si) { if (this.pildora && this.cfg.pildora === 'true') this.pildora.hidden = !si; }

    alClic(e) {
      if (e.target === this.d) {
        const r = this.d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.cerrar();
        return;
      }
      const b = e.target.closest('button');
      if (!b || !this.el.contains(b)) return;
      if (b.hasAttribute('data-q4bv-cerrar')) { this.cerrar(); return; }
      if (b.hasAttribute('data-q4bv-copiar')) this.copiar(b);
    }

    async copiar(b) {
      try { await navigator.clipboard.writeText(this.codigo); } catch {
        const t = document.createElement('textarea');
        t.value = this.codigo; document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); } catch {}
        t.remove();
      }
      const txt = b.querySelector('[data-q4bv-copiar-txt]');
      if (txt) txt.textContent = this.cfg.txtCopiado || 'Copiado';
      b.dataset.copiado = 'true';
      setTimeout(() => { if (txt) txt.textContent = this.cfg.txtCopiar || 'Copiar'; b.dataset.copiado = 'false'; }, 2500);
    }

    validar(alEnviar) {
      const input = this.form.querySelector('[data-q4bv-correo]');
      const campo = this.form.querySelector('[data-q4bv-campo]');
      const err = this.form.querySelector('[data-q4bv-error]');
      const v = input.value.trim();
      let msg = '';
      if (!v) msg = this.cfg.txtVacio;
      else if (!CORREO_OK.test(v)) msg = this.cfg.txtFormato;
      campo.dataset.error = msg ? 'true' : 'false';
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      err.hidden = !msg;
      err.textContent = msg;
      if (msg && alEnviar) input.focus();
      return !msg;
    }

    error(msg) { const err = this.form.querySelector('[data-q4bv-error]'); err.textContent = msg; err.hidden = false; }

    enviar(e) {
      if (e.target !== this.form) return;
      if (!this.validar(true)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      const correo = this.form.querySelector('[data-q4bv-correo]').value.trim();
      this.cargando(true);
      if (this.prueba) {
        e.preventDefault(); e.stopImmediatePropagation();
        esperar(600).then(() => this.exito(correo));
        return;
      }
      // Envío normal (hCaptcha de Shopify valida y recarga la página); al volver, programar() abre «Listo»
      guardar(sessionStorage, CLAVE + '-pend', { c: correo });
      window.addEventListener('pageshow', () => this.cargando(false), { once: true });
    }

    cargando(si) {
      const btn = this.form.querySelector('[data-q4bv-enviar]');
      const txt = this.form.querySelector('[data-q4bv-enviar-txt]');
      if (!this.txtBoton) this.txtBoton = txt.innerHTML;
      btn.classList.toggle('is-cargando', !!si);
      btn.setAttribute('aria-busy', si ? 'true' : 'false');
      if (si) { txt.innerHTML = '<span class="q4bv__cargando" aria-hidden="true"></span> '; txt.append(this.cfg.txtCargando || ''); }
      else txt.innerHTML = this.txtBoton;
    }

    // Aplica el código sin sacar los que ya tenía el carrito; después refresca el carrito Q4 (escalera con el total descontado)
    async aplicarCodigo() {
      const cart = await leerCarrito();
      const actuales = ((cart && cart.discount_codes) || []).map((d) => d.code).filter((c) => String(c).toUpperCase() !== this.codigo);
      const nuevo = await postCarrito({ discount: actuales.concat(this.codigo).join(',') });
      await refrescarCarrito();
      return nuevo;
    }

    async exito(correo) {
      guardar(localStorage, CLAVE, { e: 'listo', t: Date.now() });
      let cart = null;
      try { await this.aplicarCodigo(); cart = await leerCarrito(); } catch {}
      this.estado(cart);
      const paso1 = this.el.querySelector('[data-q4bv-paso="invitar"]');
      const paso2 = this.el.querySelector('[data-q4bv-paso="listo"]');
      const legal = paso2.querySelector('[data-q4bv-listo-legal]');
      legal.textContent = correo ? (this.cfg.txtListoLegal || '').replace('[correo]', correo) : '';
      paso1.hidden = true;
      paso2.hidden = false;
      this.listoVisible = true;
      this.cargando(false);
      this.evento('q4_bienvenida10_suscrito', {});
      this.abrir();
      this.d.scrollTop = 0;
      const t = paso2.querySelector('[data-q4bv-listo-titulo]');
      if (t) t.focus({ preventScroll: true });
    }

    // Lo que dice el pase: lo que ya ahorra (suma de lo que descuenta el código en cada línea) o desde cuándo se descuenta
    estado(cart) {
      const span = this.el.querySelector('[data-q4bv-estado]');
      const pase = this.el.querySelector('.q4bv-pase');
      if (!span || !cart) return;
      const items = (cart.items || []).filter((i) => !(i.properties && i.properties._regalo));
      let ahorro = 0;
      (cart.items || []).forEach((i) => (i.line_level_discount_allocations || []).forEach((a) => {
        const app = a.discount_application || {};
        if (String(app.title || app.code || '').toUpperCase() === this.codigo) ahorro += a.amount || 0;
      }));
      (cart.cart_level_discount_applications || []).forEach((app) => {
        if (String(app.title || '').toUpperCase() === this.codigo) ahorro += app.total_allocated_amount || 0;
      });
      const falta = (parseInt(this.cfg.minimo, 10) || 0) - items.reduce((s, i) => s + (i.final_line_price || 0), 0);
      let msg;
      if (ahorro > 0) msg = (this.cfg.txtEstadoOk || '').replace('[ahorro]', plata(ahorro));
      else if (items.length && falta > 0) msg = (this.cfg.txtEstadoFalta || '').replace('[falta]', plata(falta));
      else if (items.length) msg = this.cfg.txtCarroNoAplica;
      else msg = this.cfg.txtEstadoVacio;
      span.textContent = msg || '';
      pase.classList.toggle('is-ok', ahorro > 0);
    }

    evento(nombre, datos) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos); } catch {}
    }
  }

  // Bajo la compra mínima (o sin decants ni packs) Shopify deja el código en el carro como «no aplicable» y lo descuenta
  // solo cuando llega: sin aviso parecía perdido. Después de cada repintado del carrito Q4 se pone o se quita el aviso
  // sobre el subtotal. Sirve también a quien llega con /discount/<código> desde los correos.
  function avisoCarrito(el) {
    const codigo = String(el.dataset.codigo || '').toUpperCase();
    const minimo = parseInt(el.dataset.minimo, 10) || 0;
    let timer = null;
    const pintar = async () => {
      const raiz = document.querySelector('[data-q4c]');
      const tot = raiz && raiz.querySelector('.q4c-tot .q4c-fila--total');
      if (!tot) return;
      const cart = await leerCarrito().catch(() => null);
      const dc = cart && (cart.discount_codes || []).find((d) => String(d.code).toUpperCase() === codigo);
      const items = cart ? (cart.items || []).filter((i) => !(i.properties && i.properties._regalo)) : [];
      let txt = '';
      if (dc && dc.applicable === false && items.length) {
        const falta = minimo - items.reduce((s, i) => s + (i.final_line_price || 0), 0);
        txt = falta > 0 ? (el.dataset.txtCarroFalta || '').replace('[falta]', plata(falta)) : (el.dataset.txtCarroNoAplica || '');
      }
      const viejo = raiz.querySelector('[data-q4bv-aviso]');
      if (!txt) { if (viejo) viejo.remove(); return; }
      if (viejo && viejo.textContent === txt) return;
      const p = viejo || document.createElement('p');
      p.className = 'q4bv-aviso-carro';
      p.setAttribute('data-q4bv-aviso', '');
      p.setAttribute('role', 'status');
      p.textContent = txt;
      if (!viejo) tot.parentElement.insertBefore(p, tot);
    };
    const pedir = () => { clearTimeout(timer); timer = setTimeout(pintar, 250); };
    let intentos = 0;
    const enganchar = () => {
      const c = carritoQ4();
      if (!c || typeof c.pintar !== 'function') { if (++intentos < 40) setTimeout(enganchar, 250); return; }
      if (c._q4bvAviso) return;
      c._q4bvAviso = true;
      const original = c.pintar;
      c.pintar = function (...args) { const r = original.apply(this, args); pedir(); return r; };
      pedir();
    };
    enganchar();
  }

  async function iniciar() {
    const el = document.querySelector('[data-q4bv10]');
    if (!el || el._q4bv10) return;
    el._q4bv10 = true;
    if (await regaloDesdeCorreo(el)) return;
    if (el.dataset.soloRegalo === 'true' || !el.querySelector('[data-q4bv-dialogo]')) return;
    if (el.dataset.codigo && el.dataset.minimo) avisoCarrito(el);
    el._q4bv10 = new Bienvenida10(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  else iniciar();

  // La píldora se aparta (html.q4bv-aparte, en q4-bienvenida.css) con menús o diálogos abiertos, junto al pie y,
  // en el celular, mientras se baja por la página. Igual que en el pop-up del regalo.
  function pildoraAparte() {
    const html = document.documentElement;
    const celular = window.matchMedia('(max-width: 749px)');
    let ultimo = window.scrollY, bajando = false, pendiente = false, alPie = false;
    const hayCapa = () => !!document.querySelector('details.menu-drawer-container[open], dialog[open]:not([data-q4bv-dialogo]), .facets__drawer[open], details.facets[open]');
    const pintar = () => { pendiente = false; html.classList.toggle('q4bv-aparte', hayCapa() || alPie || (celular.matches && bajando)); };
    const pedir = () => { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } };
    const franja = document.querySelector('.shopify-section-group-footer-group.footer-utilities');
    if (franja && 'IntersectionObserver' in window) new IntersectionObserver((e) => { alPie = e[0].isIntersecting; pedir(); }).observe(franja);
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (Math.abs(y - ultimo) < 8) return;
      bajando = y > ultimo && y > 160; ultimo = y; pedir();
    }, { passive: true });
    const revisar = () => { pedir(); setTimeout(pedir, 120); setTimeout(pedir, 450); };
    ['click', 'keyup', 'toggle', 'close'].forEach((t) => document.addEventListener(t, revisar, true));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pildoraAparte, { once: true });
  else pildoraAparte();

  // Editor del tema: abrir al seleccionar la sección
  const de = (e) => e.target && e.target.querySelector && e.target.querySelector('[data-q4bv10]');
  document.addEventListener('shopify:section:load', () => iniciar());
  document.addEventListener('shopify:section:select', (e) => { const el = de(e); if (el && el._q4bv10 && el._q4bv10.abrir) el._q4bv10.abrir(); });
  document.addEventListener('shopify:section:deselect', (e) => { const el = de(e); if (el && el._q4bv10 && el._q4bv10.cerrar) el._q4bv10.cerrar(); });
})();
